import React, { useState } from "react";
import classnames from "classnames";
import { Loading, SearchBar, Button } from "components/common";
import { useQuery, useApolloClient } from "@apollo/react-hooks";
import { MarketingMetricsTable, RETRIEVE_CAMPAIGN_METRICS } from "./marketingLanding";
import MarketingNavigation from "./utils/components/MarketingNavigation";
import MarketingContainer from "./utils/components/MarketingContainer";
import "./utils/styles/marketing-dashboard.css";

const BatchAnalytics = () => {
  const [pageMetrics, setPageMetrics] = useState([]);
  const [allCampaigns, setAllCampaigns] = useState([]);
  const [visibleCampaigns, setVisibleCampaigns] = useState([]);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [searchInput, setSearchInput] = useState('');
  const [loading, setLoading] = useState(true);
  const client = useApolloClient();

  useQuery(RETRIEVE_CAMPAIGN_METRICS, {
    variables: {},
    fetchPolicy: 'network-only',
    onCompleted: (res) => {
      const { retrieveMarketingCampaignMetrics } = res;
      const { campaigns, metrics: resMetrics, page: resPage, maxPage:resMaxPage } = retrieveMarketingCampaignMetrics;
      setAllCampaigns(campaigns);
      setPageMetrics(resMetrics);
      setPage(resPage || 0);
      setMaxPage(resMaxPage);
      setLoading(false);
    },
  });

  const searchForCampaign = (value) => {
    setSearchInput(value);
    if (value) {
      const matches = allCampaigns.filter((campaign) => {
        return campaign.batch_name.toLowerCase().startsWith(value) && pageMetrics.every((m) => m.batch_name !== campaign.batch_name);
      });

      setVisibleCampaigns(matches);
    } else {
      setVisibleCampaigns([]);
    }
  };

  const getMoreCampaignMetrics = async (uuid) => {
    setLoading(true);
    const { data: { retrieveMarketingCampaignMetrics } }
      = await client.query({
        fetchPolicy: 'network-only',
        query: RETRIEVE_CAMPAIGN_METRICS,
        variables: {
          ...(uuid ? { uuid } : { page: Number(page) + 1 }),
        },
      });

    const { metrics: resMetrics, page: resPage, maxPage: resMaxPage } = retrieveMarketingCampaignMetrics;
    const newMetrics = resMetrics.filter((rm) => pageMetrics.every((m) => m.batch_name !== rm.batch_name));
    setPageMetrics([...newMetrics, ...pageMetrics]);
    setPage(resPage);
    setMaxPage(resMaxPage);
    setLoading(false);
  };

  if (loading) {
    return (<Loading/>);
  }

  return (
    <MarketingContainer>
      <MarketingNavigation />
      <SearchBar
        id="EMAIL_TEMPLATE_SEARCH_BAR_ID"
        placeholder={page >= maxPage ? "All metrics loaded" : "Search By Batch Id"}
        value={searchInput}
        onChange={({ value }) => {
          searchForCampaign(value.toLowerCase());
        }}
      />
      { visibleCampaigns?.length > 0 && (
        <div className="flex flex-col h-full mt-2">
          <div className="rounded-sm border">
            { visibleCampaigns?.map((campaign) => {
              return (
                <div
                  key={`t-${campaign.uuid}`}
                  className={classnames("bg-white shadow-container border-b")}
                >
                  <button
                    type="button"
                    className={classnames(
                      "flex w-full px-4 py-4 outline-0-important rounded-none",
                    )}
                    onClick={() => {
                      setSearchInput('');
                      setVisibleCampaigns([]);
                      getMoreCampaignMetrics(campaign.uuid);
                    }}
                  >
                    <p>{campaign.batch_name}</p>
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div
        className={classnames("flex justify-end my-5 py-2 rounded-lg animate__animated animate__fadeIn ease-in-out")}
      >
        <Button
          className="btn flex text-sm bg-green-500 mr-2 border-none"
          onClick={() => { getMoreCampaignMetrics(); }}
          disabled={page >= maxPage}
        >
          {page >= maxPage ? "All loaded" : "Load More campaigns"}
        </Button>
      </div>
      <div className="flex pr-4">
        <p className="pr-1 font-semibold"> Showing most recently updated max 300 campaigns </p>
      </div>
      <div className="flex pr-4">
        <p className="pr-1 font-semibold"> Email: metrics for last 30 days </p>
      </div>
      <MarketingMetricsTable metrics={pageMetrics}/>
    </MarketingContainer>
  );
};

export default BatchAnalytics;